import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Contenido from "./component/Contenido";
import { ToastContainer } from 'react-toastify';
import VistaInit from './component/VistaInit';
import ListaPedidos from './component/ListaPedidos';
import RealizarReserva from './component/RealizarReserva';
import RecervasRealizadas from './component/RecervasRealizadas';
import './css/App.css'
import ConfigInicio from './component/ConfigInicio';
import QrPagoVista from './component/QrPagoVista';
import DatoAdicional from './component/DatoAdicional';
import PrincipalFexoPedido from './component/PrincipalFexoPedido';
import MapaLeaflet from './component/MapaLeaflet';
import PaginaURL from './component/PaginaURL';
import PaginaUrl_Whatsapp from './component/PaginaUrl_Whatsapp';



function App() {
  const [carrito, setCarrito] = useState(0);
  const [pantalla, setPantalla] = useState(0);
  const [cargoPagina, setCargoPagina] = useState(false);
  const [regional, setRegional] = useState(() => {
    // obtener regional del parametro de la URL
    const params = new URLSearchParams(window.location.search);
    return params.get('r') || '0';
  });
  const [regionalReal, setRegionalReal] = useState(() => {
    // obtener regional del hostname de la URL
    var r = '0';

    if (window.location.hostname == 'localhost') {
      r = '990'; // PRUEBAS
    } else if ((window.location.hostname == 'pedidos.chickenskingdom.com') || (window.location.hostname == 'cbb.chickenskingdom.com')) {
      r = '990';
    } else if ((window.location.hostname == 'pedidos.kingtor.com.bo') || (window.location.hostname == 'scz.chickenskingdom.com')) {
      r = '991';
    }

    return r;
  });
  useEffect(() => {
    //localStorage.setItem('filtroSucursal', 9);
    //localStorage.setItem("filtroCategoria", -100);
    /*fetch(`/sucursales/configuracionHorarios`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log(data.ok)
        if (data.ok) {
          localStorage.setItem("configHR", JSON.stringify(data.ok[0]));
        } else {
          msgToask.msgError(data.error);
        }
      })
      .catch(err => {
        msgToask.msgError(err.message)
      });*/
  }, [cargoPagina]);
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<ConfigInicio regional={regional} regionalReal={regionalReal} setRegional={setRegional} setPantalla={setPantalla} />} />
        <Route path='/FEXCO' element={<ConfigInicio regional={regional} regionalReal={regionalReal} setRegional={setRegional} setPantalla={setPantalla} />} />
        <Route path="/inicio" element={
          <VistaInit cargoPagina={cargoPagina} regional={regional} setCargoPagina={setCargoPagina} setPantalla={setPantalla} />} />

        <Route path="/menu"
          element={
            <Contenido
              setCarrito={setCarrito}
              carrito={carrito}
              pantalla={pantalla}
              setPantalla={setPantalla}
            />} />

        <Route path="/miPedido"
          element={
            <ListaPedidos pantalla={pantalla}
              setPantalla={setPantalla} />
          } />
        <Route path="/reservar" element={<RealizarReserva regional={regional} />} />
        <Route path="/QrPagar" element={<QrPagoVista />} />
        <Route path="/misReservas" element={<RecervasRealizadas />} />
        <Route path='/datoAdicional' element={<DatoAdicional regional={regional} />} />
        <Route path='/pedidoFexco' element={<PrincipalFexoPedido regional='990'/>} />
        <Route path='/mapaLeaflet' element={<MapaLeaflet regional='990'/>} />

        <Route path="/:regional/:id_sucursal/:piso" element={<PaginaURL />} />
        <Route path="/PaginaUrl_Whatsapp" element={<PaginaUrl_Whatsapp />} />

      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </BrowserRouter>
  );
}

export default App;
